const appName = "cisTrucklaneContentApp";

export { appName };
